<template>
  <AppHeaderDropdown right no-caret>

    <template slot="header">
      <img
        src="img/avatars/default.jpg"
        class="img-avatar"
        alt="admin@bootstrapmaster.com" />
    </template>

    <template slot="dropdown">
      <b-dropdown-header tag="div" class="text-center">
        <strong>{{username}}</strong>
      </b-dropdown-header>
<!--      <b-dropdown-header-->
<!--        tag="div"-->
<!--        class="text-center">-->
<!--        <strong>Configuración</strong>-->
<!--      </b-dropdown-header>-->
<!--      <b-dropdown-divider />-->
      <b-dropdown-item><router-link to="/logout"><i class="fa fa-lock" /> Cerrar sesión</router-link></b-dropdown-item>
    </template>

  </AppHeaderDropdown>
</template>

<script>

import { HeaderDropdown as AppHeaderDropdown } from '@coreui/vue';
import {mapGetters} from "vuex";

export default {
  name: 'DefaultHeaderDropdownAccnt',
  components: {
    AppHeaderDropdown
  },
  data: () => {
    return {
      username: 'Perico',
    }
  },

  mounted() {
    this.username = this.authUser().username
  },

  methods: {
    ...mapGetters([
      'authUser',
    ]),
  }
}
</script>
